import React from "react"

export default function DisplayOccupationPosition({
  position,
  occupation
}) {
  if(position && occupation) {
    return (
      <>
      {position}<br />{occupation}
      </>
    )
  }

  if(position && !occupation) {
    return (
      <>
      {position}
      </>
    )
  }

  if(!position && occupation) {
    return (
      <>
      {occupation}
      </>
    )
  }

  return (
    <>
    </>
  )
}
